import React, { useEffect, useState } from "react";
import axios from "axios";
import AutomobileDetails from "./AutomobileDetails";
import MobilePhoneDetails from "./MobilePhoneDetails";
import MotorcycleDetails from "./MotorcycleDetails";
import TruckDetails from "./TruckDetails";
import LaptopDetails from "./LaptopDetails";
import DesktopComputerDetails from "./DesktopComputerDetails";
import TelevisionDetails from "./TelevisionDetails";
import SparePartsDetails from "./SparePartsDetails";
import WaterTransportDetails from "./WaterTransportDetails";
import ConstructionEquipmentDetails from "./ConstructionEquipmentDetails";
import BusDetails from "./BusDetails";
import ApartmentDetails from "./ApartmentDetails";
import OfficeDetails from "./OfficeDetails";
import LandDetails from "./LandDetails";
import ClothingDetails from "./ClothingDetails";
import AccessoriesDetails from "./AccessoriesDetails";
import WatchesJewelryDetails from "./WatchesJewelryDetails";
import BirdDetails from "./BirdDetails";
import AquariumFishDetails from "./AquariumFishDetails";
import RabbitDetails from "./RabbitDetails";
import DogDetails from "./DogDetails";
import CatDetails from "./CatDetails";
import HorseDetails from "./HorseDetails";
import FarmAnimalDetails from "./FarmAnimalDetails";
import Loading from "../../../Loading";

function DynamicProductDetails({ subCategoryId, productId }) {
    const [productData, setProductData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // 🟢 API URL-ni subkategoriyaya görə müəyyən edirik
    const getApiUrl = (subCategoryId) => {
        
        switch (subCategoryId) {
            case 1: return `https://api.herracim.az/api/Automobile/${productId}`;
            case 11: return `https://api.herracim.az/api/MobilePhone/${productId}`;
            case 12: return `https://api.herracim.az/api/Laptop/${productId}`;
            case 13: return `https://api.herracim.az/api/DesktopComputer/${productId}`;
            case 14: return `https://api.herracim.az/api/Television/${productId}`;
            case 5: return `https://api.herracim.az/api/SpareParts/${productId}`;
            case 4: return `https://api.herracim.az/api/Truck/${productId}`;
            case 6: return `https://api.herracim.az/api/WaterTransport/${productId}`;
            case 8: return `https://api.herracim.az/api/ConstructionEquipment/${productId}`;
            case 9: return `https://api.herracim.az/api/Bus/${productId}`;
            case 2: return `https://api.herracim.az/api/Motorcycle/${productId}`;
            case 15: return `https://api.herracim.az/api/Apartment/${productId}`;
            case 16: return `https://api.herracim.az/api/Office/${productId}`;
            case 17: return `https://api.herracim.az/api/Land/${productId}`;
            case 18: return `https://api.herracim.az/api/Clothing/${productId}`;
            case 19: return `https://api.herracim.az/api/Accessories/${productId}`;
            case 20: return `https://api.herracim.az/api/WatchesJewelry/${productId}`;
            case 21: return `https://api.herracim.az/api/Bird/${productId}`;
            case 22: return `https://api.herracim.az/api/AquariumFish/${productId}`;
            case 23: return `https://api.herracim.az/api/Rabbit/${productId}`;
            case 24: return `https://api.herracim.az/api/Dog/${productId}`;
            case 25: return `https://api.herracim.az/api/Cat/${productId}`;
            case 26: return `https://api.herracim.az/api/Horse/${productId}`;
            case 27: return `https://api.herracim.az/api/FarmAnimal/${productId}`;
            default: return null;
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            const apiUrl = getApiUrl(subCategoryId);
            if (!apiUrl) {
                setError("Məhsul tapılmadı.");
                setLoading(false);
                return;
            }

            try {
                const response = await axios.get(apiUrl);
                setProductData(response.data);
            } catch (err) {
                console.error("Məhsulu yükləyərkən xəta baş verdi:", err);
                setError("Məhsul yüklənə bilmədi.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [subCategoryId, productId]);

    if (loading) return <Loading/>;
 

    // 🟢 Məhsulun növünə uyğun komponenti render edirik
    switch (subCategoryId) {
        
        case 1: return <AutomobileDetails product={productData} />;
        case 11: return <MobilePhoneDetails product={productData} />;
        case 12: return <LaptopDetails product={productData} />;
        case 13: return <DesktopComputerDetails product={productData} />;
        case 14: return <TelevisionDetails product={productData} />;
        case 5: return <SparePartsDetails product={productData} />;
        case 4: return <TruckDetails product={productData} />;
        case 6: return <WaterTransportDetails product={productData} />;
        case 8: return <ConstructionEquipmentDetails product={productData} />;
        case 9: return <BusDetails product={productData} />;
        case 2: return <MotorcycleDetails product={productData} />;
        case 15: return <ApartmentDetails product={productData} />;
        case 16: return <OfficeDetails product={productData} />;
        case 17: return <LandDetails product={productData} />;
        case 18: return <ClothingDetails product={productData} />;
        case 19: return <AccessoriesDetails product={productData} />;
        case 20: return <WatchesJewelryDetails product={productData} />;
        case 21: return <BirdDetails product={productData} />;
        case 22: return <AquariumFishDetails product={productData} />;
        case 23: return <RabbitDetails product={productData} />;
        case 24: return <DogDetails product={productData} />;
        case 25: return <CatDetails product={productData} />;
        case 26: return <HorseDetails product={productData} />;
        case 27: return <FarmAnimalDetails product={productData} />;
        default:
            return <p>Bu məhsul üçün xüsusi detallar mövcud deyil.</p>;
    }
}

export default DynamicProductDetails;
